'use client'

import { useEffect } from 'react'
import { useLocation } from '@/lib/router'

/** React Router doesn't reset scroll position on navigation like full page loads do. */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    // Leave anchor links (e.g. /#about) alone so they can scroll to their target.
    if (hash) return
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
